import React, { useState, useEffect } from 'react';
import { Building2, Bed, UtensilsCrossed, Bell, AlertTriangle, BarChart2, Plus } from 'lucide-react';
import { useRealtime } from '../../../contexts/RealtimeContext';
import toast from 'react-hot-toast';
import HostelSetup from './HostelSetup';
import BedAllocation from './BedAllocation';
import MessPlans from './MessPlans';
import HostelNotices from './HostelNotices';
import HostelComplaints from './HostelComplaints';
import HostelReports from './HostelReports';

const TABS = [
  { id: 'setup', label: 'Hostel Setup', icon: Building2 },
  { id: 'allocation', label: 'Bed Allocation', icon: Bed },
  { id: 'mess', label: 'Mess Plans', icon: UtensilsCrossed },
  { id: 'notices', label: 'Notices', icon: Bell },
  { id: 'complaints', label: 'Complaints', icon: AlertTriangle },
  { id: 'reports', label: 'Reports', icon: BarChart2 },
];

const HostelManagement = () => {
  const { userProfile } = useRealtime();
  const coachingId = userProfile?.coachingId || '';
  const [activeTab, setActiveTab] = useState('setup');

  if (!coachingId) {
    return <div className="p-6 text-center text-gray-500">No coaching ID found.</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Hostel & Mess Management</h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">Manage hostels, rooms, bed allocation, mess plans, notices & complaints</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
        <div className="flex space-x-1 min-w-max">
          {TABS.map(tab => {
            const Icon = tab.icon;
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  active
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon size={16} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'setup' && <HostelSetup coachingId={coachingId} />}
      {activeTab === 'allocation' && <BedAllocation coachingId={coachingId} />}
      {activeTab === 'mess' && <MessPlans coachingId={coachingId} />}
      {activeTab === 'notices' && <HostelNotices coachingId={coachingId} />}
      {activeTab === 'complaints' && <HostelComplaints coachingId={coachingId} />}
      {activeTab === 'reports' && <HostelReports coachingId={coachingId} />}
    </div>
  );
};

export default HostelManagement;
